/* Open Road · Enquiry form
   Vanilla, no deps. Two progressive enhancements, both per [data-enquiry-root]:
   1. Tabbed   (data-layout="tabbed") — clicking a [data-ef-tab] activates it and
      shows the matching [data-ef-tabpanel] by index; the rest hide.
      Inactive lanes are disabled as well as hidden, so only the chosen lane
      is submitted and hidden `required` fields cannot block the post.
   2. Wizard   (data-layout="wizard") — Next/Back buttons advance [data-ef-step]
      panels and update the step indicator. Every input stays in the DOM so the
      single native contact form submits everything in one go.
   With JS off the form is a single scrollable page that still posts; every
   lane is visible and enabled, which is verbose but never broken. */
(function () {
  'use strict';

  function initTabbed(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ef-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ef-tabpanel]'));
    if (!tabs.length || !panels.length) return;
    var lane = root.querySelector('[data-ef-lane]');

    function fieldsIn(panel) {
      return Array.prototype.slice.call(panel.querySelectorAll('input, select, textarea'));
    }

    function activate(index) {
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.hidden = !on;
        /* Disable the inputs of every lane the customer is not filling in.
           Two reasons, both real: a disabled control is not submitted, so the
           enquiry carries only the chosen lane's answers instead of a wall of
           empty fields; and a `required` field inside a hidden panel would
           otherwise fail browser validation on an element that cannot be
           focused, which blocks submission with no visible error. */
        fieldsIn(panel).forEach(function (el) {
          el.disabled = !on;
        });
      });

      /* Tell the workshop which lane this came from. */
      if (lane) {
        var chosen = tabs[index];
        lane.value = (chosen && (chosen.getAttribute('data-ef-lane-value') || chosen.textContent.trim())) || '';
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });
    });

    var def = parseInt(root.getAttribute('data-default'), 10);
    activate(isNaN(def) ? 0 : def);
  }

  function initWizard(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ef-step]'));
    if (steps.length < 2) return;
    var pips = Array.prototype.slice.call(root.querySelectorAll('[data-ef-pip]'));
    var progress = root.querySelector('[data-ef-progress]');
    var current = 0;

    function show(index) {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) {
        step.hidden = i !== current;
      });
      pips.forEach(function (pip, i) {
        pip.classList.toggle('is-active', i === current);
        pip.classList.toggle('is-done', i < current);
      });
      if (progress) {
        progress.textContent = '★ Step ' + (current + 1) + ' of ' + steps.length;
      }
      root.querySelectorAll('[data-ef-back]').forEach(function (btn) {
        btn.disabled = current === 0;
      });
    }

    root.querySelectorAll('[data-ef-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(current + 1); });
    });
    root.querySelectorAll('[data-ef-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { show(current - 1); });
    });

    show(0);
  }

  function initRoot(root) {
    if (root.dataset.efInit === 'true') return;
    root.dataset.efInit = 'true';
    var layout = root.getAttribute('data-layout');
    if (layout === 'tabbed') initTabbed(root);
    if (layout === 'wizard') initWizard(root);
  }

  function init() {
    var roots = document.querySelectorAll('[data-enquiry-root]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when a section is added/reloaded in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-enquiry-root]');
    if (root) initRoot(root);
  });
})();
